var utils = require('../../utils')

export default {
  name: 'doctor-detail',
  data: function () {
    return {
      doctor: null,
      doctorHisId: null,
      utils: utils,
      searchCallbackFlag: false // 検索結果フラグ
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('CLEAR_DOCTOR_CODE')
    next()
  },
  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.search()
  },
  computed: {
    doctorHistories() {
      return this.$store.getters.doctorHistories
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** 通知 */
    notify() {
      return this.$store.getters.doctorNotify
    },
    doctorCodeList() {
      return this.$store.getters.doctorCodeList
    }
  },
  methods: {
    search: function () {
      this.clearDoctor()
      var data = {}
      var self = this
      var callback = function(data){
        if (!data || data.length < 1) {
          self.goPrev()
          return
        }
        var exists = false
        for (var d of data) {
          if ( d.attributes['current-flag']) {
            self.doctor = d
            self.doctorHisId = d.attributes['doctor-history-id']
            exists = true
          }
        }
        // 当日日付が見つからない場合先頭
        if (!exists) {
          if (data !== null && data.length > 0) {
            self.doctor = data[0]
            self.doctorHisId = data[0].attributes['doctor-history-id']
          }
        }
        self.searchCallbackFlag = true
        self.searchDoctorCode()
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('DOCTOR_SEARCH_DETAIL', { doctorId: this.$route.params.doctorId, data: data, callback: callback })
    },
    searchDoctorCode: function () {
      var data = {
        'doctor_id': this.doctor.attributes['doctor-id']
      }
      this.$store.dispatch('DOCTOR_SEARCH_DOCTOR_CODE', {data: data})
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goPrev: function () {
      if (utils.isBlank(this.$route.params.clinicId)) {
        this.$router.push({ path: '/doctors', query: { type: this.$router.currentRoute.query.type, keep: 'true'} })
      } else {
        // クリニック指定
        this.$router.push({ path: '/doctors/list/' + this.$route.params.clinicId, query: { type: this.$router.currentRoute.query.type, keep: 'true'} })
      }
    },
    goDoctorsEdit: function () {
      if (utils.isBlank(this.$route.params.clinicId)) {
        this.$router.push({ path: '/doctors/' + this.$route.params.doctorId + '/' + this.doctorHisId + '/edit', query: { type: this.$router.currentRoute.query.type } })
      } else {
        // クリニック指定
        this.$router.push({ path: '/doctors/' + this.$route.params.doctorId + '/' + this.doctorHisId + '/edit/' + this.$route.params.clinicId, query: { type: this.$router.currentRoute.query.type } })
      }
    },
    clearDoctor: function () {
      this.doctor = null
      this.doctorHisId = null
      this.$store.dispatch('DOCTOR_DETAIL_CLEAR')
    },
    getReferenceDate: function (d) {
      // 当日が含まれている場合
      if (d.attributes['current-flag']){
        return this.$t('history.today')
      }

      var start = this.utils.sereki2Wareki(this.$t, new Date(d.attributes['start-date']))
      var end = new Date(d.attributes['end-date'])
      if (end.getFullYear() == this.$t('history.max_year')) {
        end = this.$t('history.max_display')
      } else {
        end = this.utils.sereki2Wareki(this.$t, end)
      }
      return start + this.$t('history.delimiter') + end
    },
    changeSelectDate: function () {
      for (var doc of this.doctorHistories) {
        if (doc.attributes['doctor-history-id'] == this.doctorHisId) {
          this.doctor = doc
          return
        }
      }
    },
    deleteHistory: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.search()
      }
      this.$store.dispatch('DOCTOR_DELETE', { historyId: this.doctorHisId, data: data, callback: callback})
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/doctor-detail.js